import { BANKSLIP_PAYMENT_EN_US } from "../components/bankslip-payment/translations";
import { BLOCKED_VALUE_MODAL_EN_US } from "../components/blocked-value-modal/translations";
import { FUTURE_ENTRIES_INDICATOR_EN_US } from "../components/future-entries-indicator/translations";
import { FUTURE_ENTRIES_MODAL_EN_US } from "../components/future-entries-modal/translations";
import { LATEST_TRANSACTIONS_TABLE_EN_US } from "../components/latest-transactions-table/translations";
import { SAVED_ACCOUNTS_MODAL_EN_US } from "../components/saved-accounts-modal/translations";
import { TAB_CONTENT_EN_US } from "../components/tab-content/translations";
import { TABLE_EXTRACT_EN_US } from "../components/table-extract/translations";
import { WALLET_DRAWER_EN_US } from "../components/wallet-drawer/translations";
import { WALLET_INDICATOR_EN_US } from "../components/wallet-indicator/translations";
import { FLOW_EXTRACT_EN_US } from "../pages/flow/translations";
import { ExtractTranslations } from "./extract-pt-br";

export const EXTRACT_EN_US: ExtractTranslations = {
	title: "Payment Account",
	graphics: "Graphics",
	subtitle: `Follow your financial movements clearly and understand your transactions,
		bills and withdrawals in a practical way.`,
	oldExtract: "Old Extract",
	oldExtractExpireAt: "Until 05/08/2025",
	walletIndicator: WALLET_INDICATOR_EN_US,
	futureEntriesIndicator: FUTURE_ENTRIES_INDICATOR_EN_US,
	futureEntriesModal: FUTURE_ENTRIES_MODAL_EN_US,
	tab: TAB_CONTENT_EN_US,
	tableExtract: TABLE_EXTRACT_EN_US,
	walletDrawer: WALLET_DRAWER_EN_US,
	savedAccountsModal: SAVED_ACCOUNTS_MODAL_EN_US,
	latestTransactions: LATEST_TRANSACTIONS_TABLE_EN_US,
	flow: FLOW_EXTRACT_EN_US,
	blockedValueModal: BLOCKED_VALUE_MODAL_EN_US,
	bankslipPayment: BANKSLIP_PAYMENT_EN_US,
	filterBy: "Filter by",
	typeFilter: "Type a filter",
	groupFilter: "Filter by Group",
	categoryFilter: "Filter by Category",
	groupBy: "Group by",
	groupedBy: "Grouped",
	drawer: {
		withdraw: "Withdrawal",
		anticipation: "Anticipation",
		ticketPayment: "Ticket Payment",
		transferBetweenPlaces: "Transfer Between Places",
	},
	search: {
		emptyState: "No filters found",
		clearAllTooltip: "Clear all filters",
		allItems: "All items",
	},
};
